// DOM ready
$(function () {
  // Smooth scroll for .pageLink anchors
  $(".pageLink a").on("click", function () {
    const speed = 500;
    const href = $(this).attr("href");
    const target = $(href === "#" || href === "" ? "html" : href);
    const position = target.offset().top;

    $("html, body").animate(
      { scrollTop: position },
      speed,
      "swing"
    );

    return false;
  });

  // Sequential item animation
  const animateItems = function () {
    $(".itemBox_item").each(function (i) {
      setTimeout(function () {
        $(".itemBox_item").removeClass("itemBox_visible");
        $(".itemBox_item").eq(i).addClass("itemBox_visible");
      }, 1500 * i);
    });
  };

  // Run once + repeat every 7.5s
  animateItems();
  setInterval(animateItems, 7500);

  // Add .anime when elements come into view
  $(window).on("load scroll", function () {
    $(".itemDetail > li").each(function () {
      const itemTop = $(this).offset().top;
      const scrollTop = $(window).scrollTop();
      const windowHeight = $(window).height();

      if (scrollTop > itemTop - windowHeight + windowHeight / 3) {
        $(this).addClass("anime");
      }
    });
  });
  // Slick sliders on load
  if ($.fn.slick) {
    $(".alldoll_mv").slick({
      autoplay: true,
      speed: 500,
      autoplaySpeed: 4000,
      dots: true,
      arrows: false,
      pauseOnHover: false,
      pauseOnFocus: false
    });

    $(".buyItem_slide").slick({
      autoplay: true,
      speed: 500,
      autoplaySpeed: 4000,
      dots: true,
      arrows: true,
      pauseOnHover: false,
      pauseOnFocus: false
    });
  }
});



//# sourceMappingURL=/s/files/1/0448/2334/7352/files/alldoll.js.map?v=1608533076